import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool,utils_tool } from '@/tool'
import { ExportExcel } from '../../../../../../components/index'
import { modelUtils } from '../../../../../../utils'

let { WizTypography, WizSpin, WizModal} = component_tool;
let { WizContainer } = framework_tool;
let {Session} = utils_tool
const { Paragraph } = WizTypography;

class StudentGradesFileImport extends WizContainer {
  componentName = 'studentGradesFileImport';

  constructor(props) {
    super(props)
    const {history} = props
    let applyInfo = {};
    if (history.location && history.location.pathname === '/workflow/apply/applyPlanClass/importStudentGrades') {
      if (history.location && history.location.record) {
        applyInfo = history.location.record
        Session.set('applyInfo', applyInfo)
      } else {
        applyInfo = Session.get('applyInfo') || {}
      }
    }
    this.state = {
      applyId: applyInfo.applyId
    }
  }

  _handleImport(nextProps, nextState) {
    let o = nextProps['classResultImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'导入结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  propsAndStateOnChange = {
    classResultImport: this._handleImport.bind(this),
  }

  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '学员成绩导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_classResultApply,
      }

    }
    let submit = (file, fileData) => {
      let {applyId} = this.state
      let apiPath = 'classResult/importFileForApply';
      this.doAction({
        path: apiPath,
        payload: {
          key: "importFileForApply",
          apiParams: {
            applyId: applyId,
            fileData:fileData
          }
        }
      });
    }
    let { classResultLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={classResultLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { classResult } = state;
  const classResultImport = modelUtils.getModelEntity(classResult, 'importFileForApply');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'classResult')
  return {
    classResultImport,
    ...load
  }
};

export default connect(mapStateToProps)(StudentGradesFileImport);
